// extracted by mini-css-extract-plugin
module.exports = {"container":"_3FTE3lbg-oLakz7bNZzzne","quoteBox":"_1Zs-kCNO_UPJoIoCJGp9WV"};